// extracted by mini-css-extract-plugin
module.exports = {"form":"stockfloorModal_form__2EW_M","editTableContent":"stockfloorModal_editTableContent__1XGm_"};